import isNumber from 'lodash/isNumber';

/**
 * @param {Number} number
 * @param {Number} defaultValue
 * @return {Number}
 */
export default (function (number) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Infinity;

  return isNumber(number) && !isNaN(number) ? number : defaultValue;
});